import { useSyncExternalStore } from "react";

const MOBILE_BREAKPOINT = 768;
const query = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

function subscribe(onChange: () => void) {
	const mql = window.matchMedia(query);
	mql.addEventListener("change", onChange);
	return () => mql.removeEventListener("change", onChange);
}

// Same contract as connect-v2's useIsMobile, rewritten with useSyncExternalStore
// to avoid a setState-in-effect re-render on mount.
export function useIsMobile(): boolean {
	return useSyncExternalStore(
		subscribe,
		() => window.matchMedia(query).matches,
		() => false,
	);
}
